import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import {base64MimeType,downloadBase64} from '../../utils/tools'
import Button from '@material-ui/core/Button';
import CardMedia from '@material-ui/core/CardMedia';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove
} from 'react-sortable-hoc';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

import moment from 'moment';

import 'moment/locale/fr';
import FormDialog from "./FormDialog";
moment.locale('fr');

const DragHandle = SortableHandle(() => <span><DragIndicatorIcon /></span>); // This can be any component you want


function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const SortableItem = SortableElement(({value, state, onclick, handleClickOpen, handleClose, displayConfirmation}) => {
  let mimeType = base64MimeType(value.path)
  return (
    <li className="SortableItem">
      <DragHandle />
      {value.title}
      <Tooltip title="Supprimer">
        <IconButton aria-label="Delete">
          <DeleteOutlineIcon onClick={() => displayConfirmation("Suppression", "Êtes-vous sûr de vouloir supprimer ce " + (value.filename ? "document" : "formulaire") + " ?", () => onclick(value.id, (value.filename ? "document" : "survey")))}/>
        </IconButton>
      </Tooltip>
      <Button size="small" color="primary" onClick={() => {
        if(value.filename){
            mimeType === "application/pdf" ? downloadBase64(value.path) : handleClickOpen(value.id, "document")
        }else{
            handleClickOpen(value, "survey")
        }
      }} >
          {value.filename ? "Ouvrir" : "Modifier"}
      </Button>
      <Dialog
        fullScreen
        open={state[value.id] ? state[value.id] : false}
        onClose={() => handleClose(value.id)}
        TransitionComponent={Transition}
      >
        <AppBar >
          <Toolbar>
            <IconButton color="inherit" onClick={() => handleClose(value.id)} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
          <CardMedia
          component="img"
          width="100%"
          height="auto"
          image={value.path}
          title={value.title}
        />
    </Dialog>
    </li>
  );
});

const SortList = SortableContainer(({items, state, onclick, handleClickOpen, handleClose, displayConfirmation}) => {
  return (
    <ul className="SortableList">
      {items.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} value={value} state={state} onclick={onclick} handleClickOpen={handleClickOpen} handleClose={handleClose} displayConfirmation={displayConfirmation} />
      ))}
    </ul>
  );
});

class SortableList extends Component {
  state = {
    items: [],
    survey: null,
  };

  handleClickOpen = (val, type) => {
    if(type === "survey"){
        this.setState({survey: val})
    }else{
        this.setState({ [val]: true });
    }
  };

  handleClickClose = () => {
      this.setState({ survey: null });
  };

  handleClose = (id) => {
    this.setState({ [id]: false, survey: null });
  };

  componentWillReceiveProps(nextProps) {
    let new_items = Object.assign({}, this.state, {
      items: nextProps.data.sort((a, b) => {
              return a.position - b.position;
            })
    })
    this.setState(new_items);
  }

  componentWillMount() {
    if(this.state.items.length === 0){
      let new_items = Object.assign({}, this.state, {
      items: this.props.data.sort((a, b) => {
              return a.position - b.position;
            })
      })
      this.setState(new_items);
    }
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    this.props.handleTreeChange(arrayMove(this.props.data, oldIndex, newIndex))
    this.setState({
      items: arrayMove(this.state.items, oldIndex, newIndex),
    });
  };

  render() {
    return (
      <div>
        <FormDialog edit={true} report={this.props.report} survey={this.state.survey} hideButton handleClickClose={this.handleClickClose.bind(this)}/>
        <SortList
          helperClass='sortableHelper'
          items={this.state.items}
          state={this.state}
          onclick={this.props.handleFileRemove}
          handleClickOpen={this.handleClickOpen}
          displayConfirmation={this.props.displayConfirmation}
          handleClose={this.handleClose}
          onSortEnd={this.onSortEnd}
          useDragHandle={true}
          />
      </div>
    );
  }
}
export default SortableList;



// WEBPACK FOOTER //
// ./src/component/utils/SortableList.js